import { useContext } from "react";
import { AppContext } from "../App";
import { getCurrentYear } from "../Helpers";
import { IoArrowForward } from "react-icons/io5";
import {
  CONTACT_EMAIL,
  CONTACT_LOCATION,
  CONTACT_PHONES,
} from "../views/ContactUsLanding";
import logo from "../assets/logo.png";

export default function Footer() {
  const appContext = useContext(AppContext);

  const quickLinks = [
    { label: "Home", item: "home" },
    { label: "About Us", item: "about_us" },
    { label: "Services", item: "services" },
    { label: "Contact Us", item: "contact_us" },
  ];

  return (
    <footer className="footer-modern">
      <div className="container">
        <div className="row g-4">
          <div className="col-lg-4">
            <img src={logo} width={150} className="mb-3" />
            <p className="footer-text mb-0">
              End-to-end logistics, freight forwarding, printing, stationery,
              and technology supply solutions shaped around your business.
            </p>
          </div>

          <div className="col-lg-3">
            <h6 className="footer-subtitle text-light font-semi-bold mb-3">
              Quick Links
            </h6>
            <div className="d-flex flex-column gap-2">
              {quickLinks.map((link) => (
                <button
                  key={link.item}
                  className="footer-link text-start"
                  onClick={() => appContext.navTo({ item: link.item })}
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>

          <div className="col-lg-5">
            <h6 className="footer-subtitle text-light font-semi-bold mb-3">
              Contact
            </h6>
            <div className="d-flex flex-column gap-3">
              <div>
                <p className="footer-text mb-2 text-extra">Head Office</p>
                <address className="footer-text mb-0">
                  {CONTACT_LOCATION.map((line) => (
                    <span key={line}>
                      {line}
                      <br />
                    </span>
                  ))}
                </address>
              </div>

              <div>
                <p className="footer-text mb-2 text-extra">Direct Lines</p>
                <div className="d-flex flex-column gap-1">
                  {CONTACT_PHONES.map((phone) => (
                    <a
                      key={phone.href}
                      href={phone.href}
                      className="footer-link text-start"
                    >
                      {phone.number}{" "}
                      <span className="text-light btn text-decoration-none">({phone.note})</span>
                    </a>
                  ))}
                </div>
              </div>

              <div>
                <p className="footer-text mb-2 text-extra">Email</p>
                <a href={`mailto:${CONTACT_EMAIL}`} className="footer-mail">
                  {CONTACT_EMAIL}
                </a>
              </div>

            </div>
          </div>
        </div>

        <div className="footer-bottom mt-4 pt-3 text-center">
          <p className="mb-0">
            &copy; {getCurrentYear()} PACLESE CARGO Co. Limited. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
